import React, { Component } from 'react'
import ErrorScreen from 'src/Components/ErrorScreen/ErrorScreen';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import autoLogout from 'src/Assets/Images/Plugs Illustration.svg';
import './styles.scss';
import { withTranslation } from 'react-i18next';

class InternalServerError extends Component {
  state = {
    loginType: ''
  }
  componentDidMount(){
    const { i18n } = this.props;
    i18n.changeLanguage(localStorage.getItem('authLang'));
    this.props.stopInitLoading();
  }
  
  render() {
    const { t } = this.props;
    const autoLoggedOutData = {
      img: autoLogout,
      header: t('errorHeader'),
      subHeader: t('errorSubtext')
    }
    return (
      
      <div className="internal-server-error-wrapper">
          <ErrorScreen data={autoLoggedOutData}>
            <div className="auto-button-wrapper">
              <PrimaryButtonGE
                className="btn1-class"
                text={t('retry')}
                //onClick={(redirect)}
                onClick={() =>  window.location.href = `${window.location.origin}`}
              />
            </div>
         </ErrorScreen>
        <div className="need-help">{t('needHelp')} <a className="contact-us" href="https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert">{t('contactUsPrefix')}</a> </div>     
      </div>
     
    );
  }
}

export default withTranslation()(InternalServerError);